exports.shouldUpdateScroll = ({ routerProps }) => {
  return routerProps.location.search ? false : true;
};
